import { createSelector } from '@reduxjs/toolkit';
import { selectOffersHistory } from './selectOffersHistory';

export const selectOffersHistoryExists = createSelector(
  selectOffersHistory,
  ({ offersHistoryExists }) => offersHistoryExists,
);
